import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { fetchCountries } from "./countryThunk";
import { ICountrySliceState } from "../../utils/country.types";

/**
 * Country slice initial state.
 */
const initialState: ICountrySliceState = {
    countries: [],
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * Country Slice.
 */
const countrySlice = createSlice({
    name: 'country',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch countries
            .addCase(fetchCountries.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCountries.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.countries = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchCountries.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            
    }
});

export default countrySlice.reducer;
